import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  credential: "include",
  withCredentials: true,
});

export const fetchSuggestions = (q) => api.get(`/destinations?q=${q}`);

export const fetchExperiences = (destination) =>
  api.get(`/experiences?d=${destination}`);
